import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  AddContestantCommand,
  ContestDetailsModel,
  ContestModel,
} from '../../models/Contest';

interface IContestService {
  getContests: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ContestModel[]>>;
  getContestDetails: (
    contestId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<ContestDetailsModel>>;
  addContestant: (
    data: AddContestantCommand,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  openContestTerms: (
    contestId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
}

export const contestService: IContestService = {
  getContests(axiosConfig) {
    return ajax.get(`${config.benefitApiUrl}/contests`, axiosConfig);
  },
  getContestDetails(contestId, axiosConfig) {
    return ajax.get(
      `${config.benefitApiUrl}/contests/${contestId}`,
      axiosConfig,
    );
  },
  addContestant(data, axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/contests/${data.contestId}/contestant`,
      data,
      axiosConfig,
    );
  },
  openContestTerms(contestId, axiosConfig) {
    return ajax.openPdf(
      `${config.benefitApiUrl}/contests/${contestId}/terms`,
      axiosConfig,
    );
  },
};
